
import SpeedkitPicture from '#speedkit/components/SpeedkitPicture'

export default {
  name: 'ArticleCard',
  components: { SpeedkitPicture },
  props: {
    title: {
      required: true,
      type: String,
    },
    description: {
      required: true,
      type: String,
    },
    link: {
      required: true,
      type: String,
    },
    image: {
      required: true,
      type: Object,
    },
    type: {
      required: false,
      type: String,
    }
  },
}
